import { Routes } from '@angular/router';
import { Stock } from './stock/stock';
import { LoginComponent } from './auth/login/login.component';
import { Dashboard } from './dashboard/dashboard';
import { LoginInfo } from './login-info/login-info';
import { Users } from './users/users';
import { Player } from './player/player';
import { Supplier } from './supplier/supplier';
import { Payment } from './payment/payment';
import { PaymentRuns } from './payment/payment-runs/payment-runs';
import { PaymentContracts } from './payment/payment-contracts/payment-contracts';
import { PaymentSettlements } from './payment/payment-settlements/payment-settlements';
import { PaymentRequests } from './payment/payment-requests/payment-requests';
import { PaymentRequestDetail } from './payment/payment-request-detail/payment-request-detail';
import { PaymentMethods } from './payment/payment-methods/payment-methods';
import { PaymentSources } from './payment/payment-sources/payment-sources';
import { PaymentCrypto } from './payment/payment-crypto/payment-crypto';
import { Accounting } from './accounting/accounting';
import { Report } from './report/report';
import { SupplierSettings } from './setting/supplier-settings/supplier-settings';
import { SettingsPage } from './setting/settings-page/settings-page';
import { Proxy } from './proxy/proxy';
import { authGuard } from './auth/auth.guard';
import { superAdminGuard } from './auth/super-admin.guard';
import { nonSupplierGuard } from './auth/non-supplier.guard';
import { playerAccessGuard } from './auth/player-access.guard';
import { adminGuard } from './auth/admin.guard';
import { permissionGuard } from './auth/permission.guard';
import { auctionAccessGuard } from './auth/auction-access.guard';
import { buyContractAccessGuard } from './auth/buy-contract-access.guard';
import { ContractStatusComponent } from './player-auction/contract-status/contract-status';
import { OutsourcingStatusComponent } from './player-auction/outsourcing-status/outsourcing-status';
import { PlayerAuction } from './player-auction/player-auction';
import { ContractPublicStatusSeller } from './player-auction/contract-public-status-seller/contract-public-status-seller';
import { BuyContractPage } from './player-auction/buy-contract/buy-contract';
import { ContractPublicStatusBuyer } from './player-auction/buy-contract/contract-public-status-buyer/contract-public-status-buyer';

export const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'dashboard', component: Dashboard, canActivate: [authGuard] },
  { path: 'stocks', component: Stock, canActivate: [authGuard, permissionGuard('contracts')] },
  { path: 'players', component: Player, canActivate: [authGuard, playerAccessGuard, permissionGuard('system')] },
  { path: 'login-info', component: LoginInfo, canActivate: [authGuard, permissionGuard('accounts_reports')] },
  { path: 'users', component: Users, canActivate: [authGuard, superAdminGuard] },
  { path: 'player-auction/:orderId/buyer', component: ContractStatusComponent }, // TODO: remove this
  { path: 'pa/:orderId/buyer', component: ContractStatusComponent }, // using pa instead of player-auction to avoid customer confusion
  { path: 'pa/:orderId/tracking', component: OutsourcingStatusComponent }, // public buyer tracking link keyed by provider order id
  { path: 'suppliers', component: Supplier, canActivate: [authGuard, adminGuard, permissionGuard('suppliers_payments')] },
  { path: 'stock-reports', redirectTo: 'payments', pathMatch: 'full' }, // old bookmarks
  {
    // Each tab is a sub-route so a reload stays on it instead of resetting to the first tab.
    path: 'payments',
    component: Payment,
    canActivate: [authGuard, adminGuard, permissionGuard('suppliers_payments')],
    children: [
      { path: '', redirectTo: 'runs', pathMatch: 'full' },
      { path: 'runs', component: PaymentRuns },
      { path: 'contracts', component: PaymentContracts },
      { path: 'requests', component: PaymentRequests },
      { path: 'requests/:id', component: PaymentRequestDetail },
      { path: 'settlements', component: PaymentSettlements },
      { path: 'methods', component: PaymentMethods },
      { path: 'sources', component: PaymentSources },
      { path: 'crypto', component: PaymentCrypto },
    ],
  },
  { path: 'reports', component: Report, canActivate: [authGuard, adminGuard, permissionGuard('accounts_reports')] },
  { path: 'accounting', component: Accounting, canActivate: [authGuard, adminGuard, permissionGuard('suppliers_payments')] },
  { path: 'supplier-settings', component: SupplierSettings, canActivate: [authGuard, adminGuard, permissionGuard('suppliers_payments')] },
  { path: 'settings', component: SettingsPage, canActivate: [authGuard, adminGuard, permissionGuard('system')] },
  { path: 'proxies', component: Proxy, canActivate: [authGuard, adminGuard, permissionGuard('system')] },
  { path: 'player-auction', component: PlayerAuction, canActivate: [authGuard, auctionAccessGuard, permissionGuard('contracts')] },
  { path: 'player-auction/buy-contract', component: BuyContractPage, canActivate: [authGuard, buyContractAccessGuard, permissionGuard('contracts')] },
  { path: 'player-auction/:contractId/seller', component: ContractPublicStatusSeller },
  { path: 'buy-contract/:contractId', component: ContractPublicStatusBuyer }
];
